import Hero from "@/components/sections/Hero";
import AboutSection from "@/components/sections/About";
import ProcessSection from "@/components/sections/Process";
import SolutionsSection from "@/components/sections/Solutions";
import ExpertiseSection from "@/components/sections/Expertise";
import SourcingSection from "@/components/sections/Sourcing";
import ApplicationsSection from "@/components/sections/Applications";
import WhySection from "@/components/sections/Why";
import MarketExperience from "@/components/sections/MarketExperience";
import FinalCta from "@/components/sections/FinalCta";
import SeoHead from "@/components/SeoHead";

export default function Home() {
  return (
    <div data-testid="page-home">
      <SeoHead titleKey="seo.home_title" descKey="seo.home_desc" />
      <Hero />
      <AboutSection />
      <ProcessSection />
      <SolutionsSection />
      <ExpertiseSection />
      <SourcingSection />
      <ApplicationsSection />
      <WhySection />
      <MarketExperience />
      <FinalCta />
    </div>
  );
}
